import {
  missingDataTypes,
  notActiveOnTypes,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/constants'

export const maxCriteriaPills = 5

export const missingDataLabels = {
  [missingDataTypes.scenarioItems]: 'Sin artículos en el escenario actual',
  [missingDataTypes.scenarioShipments]: 'Sin envíos en el escenario actual',
  [missingDataTypes.scenarioReturnRequests]: 'Sin solicitudes de devolución en el escenario actual',
  [missingDataTypes.realOrderItems]: 'Este pedido no tiene artículos',
  [missingDataTypes.realOrderShipments]: 'Este pedido no tiene envíos',
}

export const notActiveOnLabels = {
  [notActiveOnTypes.previewDate]: 'No activo en la fecha seleccionada',
  [notActiveOnTypes.today]: 'No activo hoy',
}

export const barShortLabels = {
  date: 'Oculto por fecha',
  criteria: 'Oculto por criterios de visibilidad',
  dateAndCriteria: 'Oculto por fecha y criterios de visibilidad',
}
